/**
 * Extract a user-facing message from a thrown error.
 *
 * oRPC's client deserializes error responses into ORPCError instances whose
 * `.message` is already the server-provided string (see StandardRPCLinkCodec
 * + isORPCErrorJson). Since ORPCError extends Error, we can treat all Error
 * subclasses uniformly here and just surface `.message`.
 */
export function extractErrorMessage(err: unknown): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }
  return 'Something went wrong. Please try again.';
}
